<template>
  <div class="footerInfo-container" v-reveal>
    <div class="introduce-container global-container">
      <div class="introduce-left">
        <img class="image" :src="oss('logo.png')" alt="启愉智能 INSPIRER" />
        <!-- TODO: 替换为启愉智能正式注册地址 -->
        <div class="address">
          地址：广东省广州市番禺区（启愉智能研发总部）
        </div>
        <div class="iphone">电话：13326445858</div>
        <div class="qr-code">
          <div class="item">
            <img class="image-qr" :src="oss('home/qr-gzh.jpg')" />
            <p>启愉微信公众号</p>
          </div>
          <div class="item">
            <img class="image-qr" :src="oss('home/qr-wechat.png')" />
            <p>微信咨询</p>
          </div>
        </div>
      </div>
      <div class="introduce-right">
        <div class="item" v-for="item in introduceData" :key="item.title">
          <h2 @click="goTo(item.path)">{{ item.title }}</h2>
          <ul>
            <li
              v-for="section in item.sections"
              :key="section.id"
              @click="goTo(item.path, section.id)"
            >
              {{ section.label }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright-container global-container">
      <div class="horizontal-line"></div>
      <div class="copyright">
        Copyright © 2020-2026 广州启愉智能科技有限公司 版权所有
      </div>
      <div class="filings">粤ICP备2025406286号</div>
    </div>
  </div>
</template>
<script setup lang="ts" name="FooterInfo">
import { oss } from "@/utils/oss";
import { reactive, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

// 每个分类对应一个页面路由，子项对应该页面内的锚点 id
const introduceData = reactive([
  {
    title: "首页",
    path: "/",
    sections: [
      { label: "企业简介", id: "about" },
      { label: "发展历程", id: "history" },
      { label: "产品与服务", id: "products" },
      { label: "数智养鱼系统", id: "system" },
    ],
  },
  {
    title: "产品介绍",
    path: "/product",
    sections: [
      { label: "产品展示", id: "product-show" },
      { label: "市场痛点", id: "pain" },
      { label: "核心优势", id: "advantages" },
      { label: "AI 养鱼管家", id: "butler" },
      { label: "智能配置", id: "spec" },
    ],
  },
  {
    title: "数字化平台",
    path: "/platform",
    sections: [
      { label: "大数据分析", id: "bigdata" },
      { label: "私域管理", id: "civic" },
      { label: "精准服务", id: "precision" },
    ],
  },
  {
    title: "定制化服务",
    path: "/customization",
    sections: [
      { label: "定制服务", id: "service" },
      { label: "部分案例", id: "cases" },
      { label: "定制流程", id: "process" },
      { label: "服务优势", id: "advantage" },
      { label: "客户反馈", id: "feedback" },
    ],
  },
  {
    title: "联系我们",
    path: "/contact",
    sections: [
      { label: "公司地址", id: "location" },
      { label: "联系方式", id: "contact-info" },
      { label: "加入我们", id: "join" },
      { label: "合作联系", id: "cooperate" },
    ],
  },
]);

// 平滑滚动到目标锚点。用原生 scrollIntoView（自动兼容 autofit 的缩放变换），
// 顶部固定导航的遮挡高度由各锚点的 scroll-margin-top 预留。
function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function goTo(path: string, id?: string) {
  if (route.path === path) {
    if (id) scrollToId(id);
    else
      (document.querySelector(".wrap") as HTMLElement | null)?.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    return;
  }
  router.push(path).then(() => {
    // 等待新页面渲染后再滚动到锚点
    nextTick(() => {
      if (id) setTimeout(() => scrollToId(id), 80);
    });
  });
}
</script>

<style scoped lang="scss">
.footerInfo-container {
  width: 100%;
  height: 100%;
  background: #f2f5fa;
  font-family: $font-body;
  .introduce-container {
    height: 262px;
    // background-color: yellow;
    padding-top: 64px;
    display: flex;
    justify-content: space-between;
    .introduce-left {
      width: 359px;
      height: 100%;
      //   background-color: #858c99;
      font-weight: 400;
      .image {
        width: 170px;
        height: auto;
      }
      .address {
        display: inline-block;
        font-size: 14px;
        color: #858c99;
        line-height: 22px;
        margin-top: 28px;
      }
      .iphone {
        display: inline-block;
        font-size: 14px;
        color: #858c99;
        line-height: 22px;
        margin-top: 8px;
      }
      .qr-code {
        width: 244px;
        margin-top: 25px;
        display: flex;
        justify-content: space-between;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .image-qr {
            width: 104px;
            height: 104px;
            // 与联系页一致：白色卡片框收齐两张二维码的视觉尺寸
            box-sizing: border-box;
            padding: 8px;
            background: #ffffff;
            border: 1px solid #e8ecf2;
            border-radius: 10px;
            object-fit: contain;
          }
          p {
            margin: 10px 0 0;
            font-size: 14px;
            color: #858c99;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
    .introduce-right {
      width: 696px;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .item {
        // display: inline-block;
          display: flex;
          flex-direction: column;
          text-align: left;
        
        h2 {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          text-align: left;
          cursor: pointer;
          transition: color 0.25s ease;
          &:hover {
            color: $primary;
          }
        }
        ul li {
          font-size: 14px;
          color: #858c99;
          line-height: 22px;
          margin-top: 10px;
          cursor: pointer;
          transition: color 0.25s ease;
          &:hover {
            color: $primary;
          }
        }
      }
    }
  }
  .copyright-container {
    height: 94px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 28px;

    .horizontal-line {
      width: 100%;
      border: 1px solid #dcdfe5;
    }
    .copyright {
      display: inline-block;
      margin-top: 20px;
      font-size: 16px;
      color: #858c99;
      line-height: 22px;
      text-align: center;
    }
    .filings {
      display: inline-block;
      font-size: 16px;
      color: #858c99;
      line-height: 22px;
      margin-top: 10px;
    }
  }
}
</style>
